module.exports = "<div class=\"container\">\r\n    <p>\r\n        Layout\r\n        <a uiSref=\"show.master\" uiSrefActive=\"btn-primary\" appUiSrefNotActive=\"btn-secondary\" class=\"btn ml-sm-3\">All Channels</a>\r\n        <a uiSref=\"show.newspaper\" uiSrefActive=\"btn-primary\" appUiSrefNotActive=\"btn-secondary\" class=\"btn\">Newspaper</a>\r\n    </p>\r\n</div>\r\n\r\n<ui-view></ui-view>"


//////////////////
// WEBPACK FOOTER
// D:/OTHERS/FirstmediaShowSchedule/src/app/show/show.component.html
// module id = ../../../../../src/app/show/show.component.html
// module chunks = main